
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObcBadgeCommand as ObcBadgeCommandElement} from '@oicl/openbridge-webcomponents/dist/navigation-instruments/badge-command/badge-command.js';
 
 
 

 
 export const ObcBadgeCommand = createComponent({
   react: React,
   tagName: 'obc-badge-command',
   elementClass: ObcBadgeCommandElement,
   events: {
     
   }
  });
 
 